import { render, staticRenderFns } from "./FpAbbreviation.vue?vue&type=template&id=ea51ad60&"
import script from "./FpAbbreviation.vue?vue&type=script&lang=js&"
export * from "./FpAbbreviation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports